import axios from 'axios';
import { Owner, CounterpartyWithTotal } from '../types/models';
import { API_BASE } from './config';

export async function getOwners(params?: Record<string | number, string | number | boolean>): Promise<Owner[]> {
  try {
    const res = await axios.get<Owner[]>(`${API_BASE}/owners`, params ? { params } : undefined);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getOwner(id: number): Promise<Owner> {
  try {
    const res = await axios.get<Owner>(`${API_BASE}/owners/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function createOwner(owner: Partial<Owner>): Promise<Owner> {
  try {
    const res = await axios.post<Owner>(`${API_BASE}/owners`, { owner });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function updateOwner(id: number, owner: Partial<Owner>): Promise<Owner> {
  try {
    const res = await axios.put<Owner>(`${API_BASE}/owners/${id}`, { owner });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function deleteOwner(id: number): Promise<void> {
  try {
    await axios.delete(`${API_BASE}/owners/${id}`);
  } catch (err) {
    throw err;
  }
}

export async function getOwnerCounterparties(id: number): Promise<CounterpartyWithTotal[]> {
  try {
    const res = await axios.get<CounterpartyWithTotal[]>(`${API_BASE}/owners/${id}/counterparties`);
    return res.data;
  } catch (err) {
    throw err;
  }
} 

export async function generateOwnerKeypair(id: number, count: number = 1): Promise<{ csv: string }>{
  const res = await axios.post<{ csv: string }>(`${API_BASE}/owners/${id}/generate_keypair`, { count });
  return res.data;
}